import { useCallback } from "react";
export var BbtReactComponent = {};
export function useGlobalOption(options) {
  if (options) {
    BbtReactComponent.options = options;
  }
}
export var useRem = function (px2rem) {
  return useCallback(function (px) {
    var _a, _b;

    if (px == 0) return "0";
    if (!px) return "auto";
    return typeof px2rem === "function" ? px2rem(px) : typeof ((_a = BbtReactComponent.options) === null || _a === void 0 ? void 0 : _a.px2rem) === "function" ? (_b = BbtReactComponent.options) === null || _b === void 0 ? void 0 : _b.px2rem(px) : px;
  }, [px2rem]);
};